import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const KeyPointsRows = styled(FlexColumn)`
  gap: 24px;

  ${QUERIES.largeTabletAndUp} {
    row-gap: 48px;
    column-gap: 24px;
  }
`;

export const KeyPointsRow = styled.div<{ itemCount: number }>`
  display: grid;
  gap: 24px;

  grid-template-columns: repeat(1, 1fr);

  ${QUERIES.largeTabletAndUp} {
    grid-template-columns: ${({ itemCount }) => `repeat(${itemCount}, 1fr);`};
  }
`;
